import { ChangeDetectorRef, Component } from '@angular/core'
import { OrderConfirmationShippingComponent } from '@spartacus/order/components'
import { TranslationService } from '@spartacus/core'
import { OrderFacade } from '@spartacus/order/root'

@Component({
    selector: 'app-custom-order-confirmation-shipping',
    templateUrl: './custom-order-confirmation-shipping.component.html',
    styleUrls: ['./custom-order-confirmation-shipping.component.scss'],
    standalone: false
})
export class CustomOrderConfirmationShippingComponent extends OrderConfirmationShippingComponent {
  constructor(
    protected orderFacade: OrderFacade,
    protected translationService: TranslationService,
    protected cd: ChangeDetectorRef
  ) {
    super(orderFacade, translationService, cd)
  }
}
